import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '@store/index'
import { get } from 'lodash'
import { isTokenInLocalStorage } from '@/utils/boot-actions'

Vue.use(Router)

const RO_PERMISSION = 'access-research-output'
const DATA_IMPORTS_PERMISSION = 'perform-data-imports'

const requiresRoAccessButDoesntHave = meta => {
  return 'requiresRoAccess' in meta && meta.requiresRoAccess && !store.getters.hasPermission(RO_PERMISSION)
}

const requiresDataImportsAccessButDoesntHave = meta => {
  return (
    'requiresDataImportsAccess' in meta &&
    meta.requiresDataImportsAccess &&
    !store.getters.hasPermission(DATA_IMPORTS_PERMISSION)
  )
}

const navigatingToChildRoutes = (to, from) => {
  if (from.path === '/') return true // the page just entered or refreshed
  const toBegins = to.path.split('/')[1]
  const fromBegins = from.path.split('/')[1]
  return toBegins === fromBegins
}

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [...routes]
})

router.beforeEach(async (to, from, next) => {
  if (!navigatingToChildRoutes(to, from)) {
    // cancel pending requests if we are not in child routes
    store.dispatch('requests/cancel')
  }

  const isAuthenticated = isTokenInLocalStorage()

  if (isAuthenticated && !store.state.settingsFetched) {
    store.commit('setLoader', true)
    await store.dispatch('entity-labels/getAndSetEntities')
    await store.dispatch('getDefaultSettings')
    store.commit('setLoader', false)
  }

  if (to.meta.requiresAuth && !isAuthenticated) {
    if (get(store, 'state.requestCancellationToken')) store.state.requestCancellationToken.cancel()
    store.dispatch('resetState')
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (['login', 'reset-password'].includes(to.name)) {
    if (isAuthenticated && !to.query.redirect) {
      next({ name: 'dashboard' })
    } else if (isAuthenticated && to.query.redirect) {
      next({ path: to.query.redirect })
    } else {
      next()
    }
  } else if (requiresRoAccessButDoesntHave(to.meta) || requiresDataImportsAccessButDoesntHave(to.meta)) {
    next({ name: 'not-found' })
  } else {
    next()
  }
})

/* Vue Router is not meant to handle absolute urls. */
/* So whenever we want to deal with those, we can use this.$router.absUrl(url) */
Router.prototype.absUrl = function(url, newTab = true) {
  const link = document.createElement('a')
  link.href = url
  link.target = newTab ? '_blank' : ''
  if (newTab) link.rel = 'noopener noreferrer'
  link.click()
}

export default router
